import { useQuery } from '@apollo/client'
import { UserDeleted, UserDeletedVariables } from '../../types'
import { USER_DELETED } from './operations'

interface Props {
  id: string
}

export const UseUserDeleted = ({ id }: Props) =>
  useQuery<UserDeleted, UserDeletedVariables>(USER_DELETED, {
    variables: { id },
  })
